import { EmployeeDto, EmployeeWithPrioritiesDto } from '../api';

export type Employee = {
  id: number;
  firstName: string;
  lastName: string;
};

export function employeeFromDto(dto: EmployeeWithPrioritiesDto | EmployeeDto): Employee {
  return {
    id: dto.id,
    firstName: dto.firstName ?? '',
    lastName: dto.lastName ?? '',
  };
}
